module.exports = __webpack_public_path__ + "fonts/Luscious-Lifestyles-Script.5d49e8b3.otf";